import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "app/auth/authRoles";
import { Navigate } from "react-router-dom";

const Undertimes = Loadable(lazy(() => import("./Undertime")));
const Overtimes = Loadable(lazy(() => import("./Overtime")));
const Leaves = Loadable(lazy(() => import("./Leaves")));

const TimeKeepingRoutes = [
  {
    path: "/overtime",
    element: <Navigate to="/timekeeping/overtime" />,
    auth: authRoles.user,
  },
  {
    path: "/undertime",
    element: <Navigate to="/timekeeping/undertime" />,
    auth: authRoles.user,
  },
  {
    path: "/leaves",
    element: <Navigate to="/timekeeping/leave" />,
    auth: authRoles.user,
  },
  { path: "/timekeeping/leave", element: <Leaves />, auth: authRoles.user },
  {
    path: "/timekeeping/undertime",
    element: <Undertimes />,
    auth: authRoles.user,
  },
  {
    path: "/timekeeping/overtime",
    element: <Overtimes />,
    auth: authRoles.user,
  },
];

export default TimeKeepingRoutes;
